// extracted by mini-css-extract-plugin
module.exports = {"container":"Legal_container__20lkv","back":"Legal_back__2D3oC","content":"Legal_content__1_rLM","bloc":"Legal_bloc__37v0g","intro":"Legal_intro__3OGmT","end":"Legal_end__hMNUQ"};